import React from "react"
import { Box, IconButton, Text } from "@chakra-ui/react"
import Icon from "components/elements/Icon"
import { useEditorLayout } from "components/CanvasEditor/EditorLayout"
import SidePanelHeader from "../SidePanelHeader"
import BadgeLayersSection from "./BadgeLayersSection"

/**
 * LayersPanel
 *
 * Panel content for the layers panel (left panel).
 * Includes header with toggle button and layers list.
 */
const LayersPanel = () => {
  const { leftPanelOpen, toggleLeftPanel } = useEditorLayout()

  return (
    <Box bgColor="gray.100" p={0} py={2}>
      <SidePanelHeader
        rightElement={(
          <IconButton
            aria-label={leftPanelOpen ? "Close left panel" : "Open left panel"}
            icon={leftPanelOpen ? <Icon icon="prev-arrow" /> : <Icon icon="next-arrow" />}
            onClick={toggleLeftPanel}
            size="xs"
            variant="ghost"
            color="gray.600"
          />
        )}
      >
        <Text px={2}>Layers</Text>
      </SidePanelHeader>
      <BadgeLayersSection />
    </Box>
  )
}

export default LayersPanel
